










































































































































































































































































































































































import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, TipoRol } from '@/config/enums';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import store from '@/store';
import { RolesInterface } from '@/interfaces/Roles';
import { PerfilesInterface, PerfilRolInterface } from '@/interfaces/Perfiles';
import { IClientes } from '@/interfaces/Clientes';
import { LoadingService } from '@/services/loadingService';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { EstadoEntidad } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Validator } from 'vee-validate';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { differenceBy } from 'lodash';
import {
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellContextMenuEvent,
  RowNode,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');
import { MarcaBlanca } from '@/config/marcaBlanca.ts';
let marcaBlanca: MarcaBlanca = new MarcaBlanca();

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class RolesTransversalModalNuevo extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ id: 0, name: '', estado: 0 }) })
  rol!: RolesInterface;

  readonly controller: string = 'Rol';
  readonly rolTransversalController: string = 'RolTransversal';
  readonly perfilTransversalController: string = 'PerfilTransversal';
  readonly clienteController: string = 'cliente';
  readonly clienteRolController: string = 'ClienteRol';
  readonly perfilController: string = 'perfil';

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.RolesTransversal;
  permisosActuales: PermisoAccionVm[] = [];
  marcaBlanca: MarcaBlanca = new MarcaBlanca();

  informacionGeneral: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  asociarPerfiles: PermisoAccionVm = {
    accion: 'Crear - Asociar Perfiles',
    visible: true,
    step: 2,
    codigoSubAccion: 23,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  asociarUsuarios: PermisoAccionVm = {
    accion: 'Crear - Asociar Clientes',
    visible: true,
    step: 3,
    codigoSubAccion: 25,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.asociarPerfiles,
    this.asociarUsuarios,
  ];

  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  axiosCliente: AxiosVue = new AxiosVue(ServicioProxy.Cliente);
  axiosPg: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

  //Variables globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  editedItem: RolesInterface = {};
  dictionaryFormErrors: any = {};
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  handleErrors: HandleErrors = new HandleErrors();
  search: string = '';
  buscarCliente: string = '';
  buscarPerfil: string = '';

  clienteId: number = config.getClienteSesion();
  usuarioId: number = store.state.userId;
  clientesAsignadosModel: any = [];
  clientesAsignados: IClientes[] = [];

  clientesTotales: IClientes[] = [];

  loadingService = new LoadingService();

  perfilesAsignadosModel: any = [];
  perfilesAsignados: PerfilesInterface[] = [];
  perfilesRespaldo: PerfilesInterface[] = [];

  // grilla
  autoGroupColumnDef: any = null;
  localeText: any = config.agGridTextos;

  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  sideBar: any = config.agGridDefaultConfig;

  gridApiPerfil: GridApi;
  columnApiPerfil: ColumnApi;
  columnDefsPerfil: Array<ColDef> = [];

  //Tipos de Rol
  tiposRol: any = [];
  selectedTipoRol: any = null;
  idRolCliente = TipoRol.Cliente;

  //Seleccionar Todos (Perfiles y Clientes)
  seleccionoTodosPerfiles: boolean = false;
  seleccionoTodosClientes: boolean = false;

  created(): void {
    this.chequearPermisos();
    this.registrarValidadores();
  }

  async mounted() {
    this.initialize();

    try {
      this.loadingService.showLoading();

      //Tipo Rol
      for (let item in TipoRol) {
        if (!isNaN(Number(item))) {
          if (Number(item) > 0) {
            let nombre = TipoRol[item];
            this.tiposRol.push({
              id: Number(item),
              nombre: nombre,
            });
          }
        }
      }
      //---

      await this.obtenerClientes();
      await this.obtenerPerfiles();
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.$snotify.error('Ocurrió un error al cargar rol transversal.');
        }
      } else {
        this.$snotify.error('Ocurrió un error al cargar rol transversal.');
      }
    } finally {
      this.loadingService.hideLoading();
    }
  }

  volver() {
    this.e1 -= 1;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    document.getElementById('cardDivR').scrollIntoView(true);
  }
  onClickCell(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }

  cierraMenuRolTransversal(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }

  private registrarValidadores(): void {
    const self = this;

    Validator.extend('RolNombreUnico', {
      getMessage() {
        return '* El nombre del Rol ya se encuentra en uso.';
      },
      validate(value: any) {
        return self.axiosCliente.http
          .get(`${self.rolTransversalController}/${0}/${value}/nombreUnico`)
          .then(response => {
            return new Promise(resolve => {
              resolve({
                valid: response.data,
                data: response.data
                  ? undefined
                  : { message: '* El nombre del Rol ya se encuentra en uso.' },
              });
            });
          })
          .catch(() => {
            return true;
          });
      },
    });
  }

  @Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.btnBloquear = false;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.clientesAsignados = [];
    this.clientesAsignadosModel = [];
    this.perfilesAsignados = [];
    this.perfilesAsignadosModel = [];

    if (value) {
      try {
        this.loadingService.showLoading();
        this.seleccionoTodosPerfiles = false;
        this.seleccionoTodosClientes = false;
        this.selectedTipoRol = null;
        this.$validator.reset();
        await this.obtenerPerfiles();
        await this.obtenerClientes();
      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error('Ocurrió un error al cargar.');
          }
        } else {
          this.$snotify.error('Ocurrió un error al cargar.');
        }
      } finally {
        this.loadingService.hideLoading();
      }
    }
  }

  nombreCompleto(cliente: IClientes): string {
    return cliente.nombre;
  }

  onUserChange(user: any) {
    window.setTimeout(() => {
      this.search = '';
    }, 100);
    if (user !== undefined && user.length !== this.clientesAsignados.length) {
      for (let x = this.clientesAsignados.length - 1; x >= 0; x--) {
        let borrar = true;

        for (let i = 0; i <= user.length - 1; i++) {
          if (this.clientesAsignados[x].id == user[i]) {
            borrar = false;
          }
        }

        if (borrar) {
          this.clientesAsignados.splice(x, 1);
        }
      }

      if (this.clientesAsignados.length === this.clientesTotales.length) {
        this.seleccionoTodosClientes = true;
      } else {
        this.seleccionoTodosClientes = false;
      }
    }
  }

  onUserInput(user: any) {
    if (user !== undefined) {
      for (let i = 0; i <= user.length - 1; i++) {
        const added = this.clientesAsignados.filter(x => x.id == user[i]);

        if (added.length === 0) {
          const cliente = this.clientesTotales.find(x => x.id == user[i]);
          this.clientesAsignados.push(cliente);

          if (this.clientesAsignados.length === this.clientesTotales.length)
            this.seleccionoTodosClientes = true;
          else this.seleccionoTodosClientes = false;
        }
      }
    }
  }

  marcarTodosClientes(value: boolean) {
    this.clientesAsignados = [];
    this.clientesAsignadosModel = [];
    if (value) {
      this.clientesTotales.forEach((cliente: any) => {
        this.clientesAsignados.push(cliente);
        this.clientesAsignadosModel.push(cliente.id);
      });
    }

    this.seleccionoTodosClientes = value;
  }

  onPerfilChange(perfil: any) {
    window.setTimeout(() => {
      this.search = '';
    }, 100);
    if (
      perfil !== undefined &&
      perfil.length !== this.perfilesAsignados.length
    ) {
      for (let x = this.perfilesAsignados.length - 1; x >= 0; x--) {
        let borrar = true;

        for (let i = 0; i <= perfil.length - 1; i++) {
          if (this.perfilesAsignados[x].id == perfil[i]) {
            borrar = false;
          }
        }

        if (borrar) {
          this.perfilesAsignados.splice(x, 1);
        }
      }

      if (this.perfilesAsignados.length === this.perfilesRespaldo.length)
        this.seleccionoTodosPerfiles = true;
      else this.seleccionoTodosPerfiles = false;
    }
  }

  onPerfilInput(perfil: any) {
    if (perfil !== undefined) {
      for (let i = 0; i <= perfil.length - 1; i++) {
        const added = this.perfilesAsignados.filter(x => x.id == perfil[i]);

        if (added.length === 0) {
          const perfilAsignar = this.perfilesRespaldo.find(
            x => x.id == perfil[i]
          );

          this.perfilesAsignados.push(perfilAsignar);

          if (this.perfilesAsignados.length === this.perfilesRespaldo.length)
            this.seleccionoTodosPerfiles = true;
          else this.seleccionoTodosPerfiles = false;
        }
      }
    }
  }

  marcarTodosPerfiles(value: boolean) {
    this.perfilesAsignados = [];
    this.perfilesAsignadosModel = [];
    if (value) {
      this.perfilesRespaldo.forEach((perfil: any) => {
        this.perfilesAsignados.push(perfil);
        this.perfilesAsignadosModel.push(perfil.id);
      });
    }
    this.seleccionoTodosPerfiles = value;
  }

  async continuar() {
    const resultado = await this.$validator.validateAll();

    if (resultado) {
      document.getElementById('cardDivR').scrollIntoView(true);

      let longPermisosActuales = this.permisosActuales.length;
      if (this.selectedTipoRol !== this.idRolCliente) {
        longPermisosActuales = longPermisosActuales - 1;
      }

      if (this.e1 === longPermisosActuales) {
        this.btnBloquear = true;
        this.dialogConfirmacion = true;
      } else if (this.e1 === longPermisosActuales - 1) {
        this.e1 += 1;
        this.btnText = 'Guardar';
        this.btnClass = 'btn-grabar';
      } else {
        this.e1 += 1;
      }
    }
  }

  async grabarAsociacionesClienteRol(rolId: number) {
    this.loadingService.showLoading();
    this.clientesAsignados.forEach(async (cliente: IClientes) => {
      try {
        const clienteRolVm = {
          id: 0,
          rolId: rolId,
          clienteId: cliente.id,
          fechaInicioAsociacion: new Date(),
          fechaCreacion: new Date(),
        };

        const response = await this.axiosCliente.http.post(
          `${this.clienteRolController}`,
          clienteRolVm
        );
      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'el Rol transversal',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'el Rol transversal',
            })
          );
        }
        this.btnBloquear = false;
      }
    });
    this.loadingService.hideLoading();
  }

  async grabarAsociacionesClienteRolV2(rolId: number) {
    this.loadingService.showLoading();
    let ids: number[] = [];
    this.clientesAsignados.forEach(async (cliente: IClientes) => {
      try {
        ids.push(cliente.id);
      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'el Rol transversal',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'el Rol transversal',
            })
          );
        }
        this.btnBloquear = false;
      }
    });

    if (ids.length > 0) {
      let datos = {
        rolId: rolId,
        clientesId: ids,
      };

      await this.axiosCliente.http.post(
        `${this.clienteRolController}/CreaClienteRol`,
        datos
      );
    }
    this.loadingService.hideLoading();
  }

  async grabarAsociacionesPerfil(rolId: number) {
    this.perfilesAsignados.forEach(async (perfil: PerfilesInterface) => {
      try {
        const response = await this.axios.http.post(
          `${this.perfilController}/${perfil.id}/rol/${rolId}`
        );
      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'el Rol transversal',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'el Rol transversal',
            })
          );
        }
        this.btnBloquear = false;
      }
    });
  }

  async guardarRolTransversal() {
    let retorno = 0;

    const vm = {
      Id: 0,
      Name: this.editedItem.name,
      Estado: EstadoEntidad.Sistema,
      Tipo: this.selectedTipoRol,
    };

    try {
      const response = await this.axiosCliente.http.post(
        this.rolTransversalController,
        vm
      );
      retorno = response.data.id;
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'el Rol transversal',
            })
          );
        }
      } else {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.crear', {
            entidad: 'el Rol transversal',
          })
        );
      }
      this.btnBloquear = false;
    }
    return retorno;
  }

  closeModal() {
    document.getElementById('cardDivR').scrollIntoView(true);
    this.btnBloquear = false;
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.buscarCliente = '';
    this.buscarPerfil = '';
    this.gridApi.setQuickFilter('');
    this.gridApiPerfil.setQuickFilter('');
  }

  formatoTextoAsociacion(texto: string) {
    return config.largoTextoAsociacion(texto);
  }

  onGridReadyPerfil(params: GridReadyEvent) {
    this.gridApiPerfil = params.api;
    this.columnApiPerfil = params.columnApi;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  async obtenerClientes(): Promise<void> {
    try {
      // const responseClientes = await this.axiosCliente.http.get(
      //   this.clienteController
      // );
      var responseClientes = await this.axiosPg.http.post('Metabase/PostgenericA/marcaBlanca/getClient', {canal: this.marcaBlanca.getSubDomain()});
      responseClientes = responseClientes.data;

      responseClientes.data = responseClientes.data.map((node: any) => ({
        ...node,
        estadoTxt: EstadoEntidad[node.estado],
        rut: node.rut === null ? '' : node.rut,
        nombre: node.nombre === null ? '' : node.nombre,
        giro: node.giro === null ? '' : node.giro,
        direccion: node.direccion === null ? '' : node.direccion,
        telefonoParticular:
          node.telefonoParticular === null ? '' : node.telefonoParticular,
      }));

      this.clientesTotales = responseClientes.data;
    } catch (e) {
      if (e.response !== undefined) {
        if (e.response.status !== 401) {
          this.$snotify.error('Ocurrió un error al obtener clientes.');
        }
      } else {
        this.$snotify.error('Ocurrió un error al obtener clientes.');
      }
    }
  }

  async obtenerPerfiles(): Promise<void> {
    try {
      const responsePerfiles = await this.axiosCliente.http.get<
        PerfilesInterface[]
      >(this.perfilTransversalController);
      //TEST
      responsePerfiles.data.forEach((perfil: PerfilesInterface) => {
        if (
          perfil.estado === EstadoEntidad.Activo ||
          perfil.estado === EstadoEntidad.Sistema
        )
          perfil.estadoTxt = 'Activo';
        else perfil.estadoTxt = 'Inactivo';
      });
      //---
      this.perfilesRespaldo = responsePerfiles.data;
    } catch (e) {
      if (e.response !== undefined) {
        if (e.response.status !== 401) {
          this.$snotify.error('Ocurrió un error al obtener Perfiles.');
        }
      } else {
        this.$snotify.error('Ocurrió un error al obtener Perfiles.');
      }
    }
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      this.btnBloquear = true;

      try {
        this.loadingService.showLoading();
        const rolId = await this.guardarRolTransversal();

        if (this.selectedTipoRol === this.idRolCliente) {
          //await this.grabarAsociacionesClienteRol(rolId);
          await this.grabarAsociacionesClienteRolV2(rolId);
        }

        await this.grabarAsociacionesPerfil(rolId);

        this.$snotify.success(
          this.$t('mensajes.mensajesExito.crear', {
            entidad: 'Rol Transversal',
            creadoA: 'creado',
          })
        );

        this.closeModal();
        this.dialogConfirmacion = false;
      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'el Rol Transversal',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'el Rol Transversal',
            })
          );
        }
        this.btnBloquear = false;
      } finally {
        this.loadingService.hideLoading();
      }
    }
    this.btnBloquear = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal();
    }
  }

  createButtonCell(params: any) {
    let evento = this.removerClienteAsignacion;
    const item = this.clientesTotales.find(x => x.id == params.data.id);

    let eButton = document.createElement('button');
    eButton.setAttribute('id', 'btnU' + params.data.id);
    eButton.setAttribute('title', 'Remover');
    eButton.setAttribute('class', 'v-btn v-btn--flat v-btn--icon theme--light');
    eButton.innerHTML =
      '<div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">delete</i></div>';

    eButton.addEventListener('click', () => {
      evento(item);
    });

    return eButton;
  }

  createButtonCellPerfil(params: any) {
    let evento = this.removerPerfilAsignacion;
    const item = this.perfilesRespaldo.find(x => x.id == params.data.id);

    let eButton = document.createElement('button');
    eButton.setAttribute('id', 'btnU' + params.data.id);
    eButton.setAttribute('title', 'Remover');
    eButton.setAttribute('class', 'v-btn v-btn--flat v-btn--icon theme--light');
    eButton.innerHTML =
      '<div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">delete</i></div>';

    eButton.addEventListener('click', () => {
      evento(item);
    });

    return eButton;
  }

  removerClienteAsignacion(item: IClientes): void {
    for (let i = 0; i <= this.clientesAsignados.length - 1; i++) {
      if (this.clientesAsignados[i].id === item.id) {
        this.clientesAsignados.splice(i, 1);
        this.clientesAsignadosModel.splice(i, 1);
        break;
      }
    }

    if (this.clientesAsignados.length === this.clientesTotales.length)
      this.seleccionoTodosClientes = true;
    else this.seleccionoTodosClientes = false;
  }

  removerPerfilAsignacion(item: PerfilRolInterface): void {
    for (let i = 0; i <= this.perfilesAsignados.length - 1; i++) {
      if (this.perfilesAsignados[i].id === item.id) {
        this.perfilesAsignados.splice(i, 1);
        break;
      }
    }

    for (let i = 0; i <= this.perfilesAsignadosModel.length - 1; i++) {
      if (this.perfilesAsignadosModel[i] === item.id) {
        this.perfilesAsignadosModel.splice(i, 1);
        break;
      }
    }

    if (this.perfilesAsignados.length === this.perfilesRespaldo.length)
      this.seleccionoTodosPerfiles = true;
    else this.seleccionoTodosPerfiles = false;
  }

  initialize() {
    this.columnDefs = [
      {
        headerName: '',
        field: 'checked',
        width: 70,
        minWidth: 70,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: (r: any) => {
          if (r.data.checked !== undefined) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
        width: 120,
        minWidth: 80,
        lockPinned: true,
        resizable: false,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Rut',
        field: 'rut',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        resizable: true,
        lockVisible: true,
        width: 200,
        minWidth: 80,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Giro',
        field: 'giro',
        resizable: true,
        width: 200,
        minWidth: 80,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Dirección',
        field: 'direccion',
        resizable: true,
        width: 200,
        minWidth: 80,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Teléfono',
        field: 'telefonoParticular',
        resizable: true,
        width: 200,
        minWidth: 80,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'estadoTxt',
        width: 200,
        minWidth: 80,
        resizable: true,
        sortable: true,
        lockPinned: true,
        // cellRenderer: (r: any) => {
        //   if (r.data.estado === EstadoEntidad.Sistema)
        //     return EstadoEntidad[EstadoEntidad.Activo];
        //   else return EstadoEntidad[r.data.estado];
        // },
        cellStyle: { textAlign: 'left' },
      },
      // {
      //   headerName: 'Desasociar',
      //   width: 150,
      //   minWidth: 80,
      //   cellRenderer: this.createButtonCell,
      //   filter: false,
      //   suppressMovable: true,
      //   resizable: false,
      //   sortable: false,
      //   lockVisible: true,
      //   pinned: 'right',
      //   cellStyle: { textAlign: 'left' },
      // },
    ];

    this.columnDefsPerfil = [
      {
        headerName: '',
        field: 'checked',
        width: 75,
        minWidth: 75,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: (r: any) => {
          if (r.data.checked !== undefined) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Código',
        field: 'id',
        width: 120,
        minWidth: 80,
        lockPinned: true,
        hide: true,
        resizable: false,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        width: 200,
        minWidth: 80,
        lockVisible: true,
        resizable: true,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Estado',
        field: 'estadoTxt',
        resizable: true,
        width: 200,
        minWidth: 80,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        // cellRenderer: (r: any) => {
        //   if (r.data.estado === EstadoEntidad.Sistema)
        //     return EstadoEntidad[EstadoEntidad.Activo];
        //   else return EstadoEntidad[r.data.estado];
        // },
      },
      // {
      //   headerName: 'Desasociar',
      //   width: 150,
      //   minWidth: 80,
      //   cellRenderer: this.createButtonCellPerfil,
      //   enablePivot: false,
      //   filter: false,
      //   suppressMovable: true,
      //   resizable: false,
      //   sortable: false,
      //   lockVisible: true,
      //   pinned: 'right',
      //   cellStyle: { textAlign: 'right' },
      // },
    ];

    this.dictionaryFormErrors = {
      custom: {
        id: {
          required: () => config.errorMensajes.textoRequerido,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          regex: config.errorMensajes.regex,
        },
        tipoRol: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
      },
    };

    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  onFilterTextBoxChanged() {
    this.gridApi.onFilterChanged();
    // if (this.buscarCliente.length > 1) {
    //   this.gridApi.setQuickFilter(this.buscarCliente);
    // } else {
    //   this.gridApi.setQuickFilter('');
    // }
  }
  onSelectionChanged() {
    this.clientesAsignados = this.gridApi.getSelectedRows();
    const clientesSeleccionados = this.gridApi
      .getSelectedNodes()
      .map(node => ({ ...node.data, checked: true }));

    const clientesNoSeleccionados = differenceBy(
      this.clientesTotales,
      clientesSeleccionados,
      cliente => cliente.id
    ).map(cliente => ({
      ...cliente,
      checked: false,
    }));

    this.gridApi.updateRowData({
      update: [...clientesNoSeleccionados, ...clientesSeleccionados],
    });
  }
  onFilterTextBoxChangedPerfil() {
    this.gridApiPerfil.onFilterChanged();
    // if (this.buscarPerfil.length > 1) {
    //   this.gridApiPerfil.setQuickFilter(this.buscarPerfil);
    // } else {
    //   this.gridApiPerfil.setQuickFilter('');
    // }
  }
  onSelectionChangedPerfil() {
    this.perfilesAsignados = this.gridApiPerfil.getSelectedRows();
    const perfilesSeleccionados = this.gridApiPerfil
      .getSelectedNodes()
      .map(node => ({ ...node.data, checked: true }));

    const perfilesNoSeleccionados = differenceBy(
      this.perfilesRespaldo,
      perfilesSeleccionados,
      perfil => perfil.id
    ).map(perfil => ({
      ...perfil,
      checked: false,
    }));

    this.gridApiPerfil.updateRowData({
      update: [...perfilesNoSeleccionados, ...perfilesSeleccionados],
    });
  }
  getRowNodeIdPerfil(perfil: PerfilesInterface) {
    if (!perfil) {
      return;
    }
    return perfil.id;
  }
  getRowNodeId(cliente: IClientes) {
    if (!cliente) {
      return;
    }
    return cliente.id;
  }

  isExternalFilterPresentPerfil(): boolean {
    return true;
  }

  doesExternalFilterPassPerfil(node: RowNode): boolean {
    if (this.perfilesRespaldo.length > 0 && this.buscarPerfil.length > 1) {
      let busqueda = this.buscarPerfil.toLowerCase();
      return (
        node.data.nombre.toLowerCase().includes(busqueda) ||
        node.data.estadoTxt.toLowerCase().includes(busqueda)
      );
    }
    return true;
  }

  isExternalFilterPresentCliente(): boolean {
    return true;
  }

  doesExternalFilterPassCliente(node: RowNode): boolean {
    if (this.clientesTotales.length > 0 && this.buscarCliente.length > 1) {
      let busqueda = this.buscarCliente.toLowerCase();
      return (
        node.data.rut.toLowerCase().includes(busqueda) ||
        node.data.nombre.toLowerCase().includes(busqueda) ||
        node.data.giro.toLowerCase().includes(busqueda) ||
        node.data.direccion.toLowerCase().includes(busqueda) ||
        node.data.estadoTxt.toLowerCase().includes(busqueda)
      );
    }
    return true;
  }
}
